import { PluginHelper } from "./PluginHelper";
import { ViewLevelSet } from "./ViewLevelSet";
import { buildViewLevelAggregate } from "./buildViewLevelAggregate";
import { computeViewLevelOfAttribute } from "./computeViewLevelOfAttribute";
export function computeViewLevel(layout, attributes) {
    // add additional data
    const rows = layout.rows.map((row) => computeViewLevelOfRow(row, attributes));
    // build aggregate
    const { viewLevels, requiredViewLevel } = buildViewLevelAggregate(rows);
    return Object.assign(Object.assign({}, layout), { requiredViewLevel,
        viewLevels,
        rows });
}
function computeViewLevelOfRow(row, attributes) {
    // add additional data
    const cells = row.cells.map((cell) => computeViewLevelOfCell(cell, attributes));
    // build aggregate
    const { viewLevels, requiredViewLevel } = buildViewLevelAggregate(cells);
    return Object.assign(Object.assign({}, row), { requiredViewLevel,
        viewLevels,
        cells });
}
function computeViewLevelOfCell(cell, attributes) {
    // add additional data
    const rows = !cell.rows
        ? []
        : cell.rows.map((row) => computeViewLevelOfRow(row, attributes));
    const data = PluginHelper.getPluginProps(cell);
    // merge aggregates
    const viewLevels = new ViewLevelSet();
    let requiredViewLevel = Number.MAX_SAFE_INTEGER;
    if (PluginHelper.isAttributePlugin(cell)) {
        // use viewLevel of the attribute
        const cellViewLevel = computeViewLevelOfAttribute(cell, attributes);
        viewLevels.add(cellViewLevel.viewLevel);
        requiredViewLevel = cellViewLevel.requiredViewLevel;
        // omit the rows of attribute cells because they of nested spacers with viewLevel 1
    }
    else {
        // use viewLevel of rows,
        const rowsViewLevel = buildViewLevelAggregate(rows);
        requiredViewLevel = rowsViewLevel.requiredViewLevel;
        viewLevels.add(0); // compatibility with tests
        viewLevels.addAll(rowsViewLevel.viewLevels);
        // add viewLevel of other components
        if (typeof data.viewLevel === "number") {
            viewLevels.add(data.viewLevel);
        }
    }
    return Object.assign(Object.assign({}, cell), { requiredViewLevel,
        viewLevels,
        rows });
}
//# sourceMappingURL=computeViewLevel.js.map